export default {
  title: "Fique ligado: vem aí o Aniversário de Sabará",
  resume: "Durante os dias 15 à 17 de julho, eventos ocorrem na cidade em comemoração ao Aniversário de Sabará",
  img: "",
  publishDate: "2025-06-29T00:00:00.000-03:00",
  content: [
    "Em comemoração ao aniversário da cidade, todas as linhas operadas pela Vinscol e as linhas 4970, 4986, 4987 e 4991, operadas pela Viação Cuiabá têm o itinerário alterado, deixando de passar pelo centro histórico e Avenida Perimetral e parte da Avenida Prefeito Victor Fantini, passando pela Avenida Central.",
    "Para maiores informações fique ligado nos avisos na página das linhas. Sempre avisaremos quando uma mudança ocorrer."
  ],
};
